import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import axios from 'axios'

import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage);

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'KouS3M4VUGoPiKq3w9GHrDa2ywn1ahTY'
})


//全局样式
import '@/assets/css/base.css'
import 'animate.css';
import 'element-ui/lib/theme-chalk/display.css';
// axios.defaults.baseURL = 'http://localhost:8080'
// axios.defaults.baseURL = 'http://www.csmjl.com'
axios.defaults.baseURL = 'http://csmjl.com'
Vue.config.productionTip = false
Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

